module.exports = __webpack_public_path__ + "img/dinning (1).3f1d07dd.jpg";